import React from 'react'

import EditableTable from '../../common/components/EditableTable'
import ToggleSwitch from '../../common/components/ToggleSwitch'

import IconButton from '../../common/components/IconButton'

import './PatternStylesTable.scss'
import TableUsedPatternSelectButton from './selects/TableUsedPatternSelectButton'
import NumberInput from '../../common/components/NumberInput'
import { iconTypes } from '../../common/components/icons/IconFactory'

function PatternStylesTable ({ data, onUnitChange }) {

  const columns = React.useMemo(
    () => [
      {
        // Expander column
        Header: () => null, // No header
        id: 'expander', // Expander Column ID
        className: 'pattern-styles-expander-column',
        Cell: ({ row }) =>
          // Use the row.canExpand and row.getExpandedToggleProps prop getter
          // to build the toggle for expanding a row
          row.getCanExpand() ? (
            <div className='expander-icon' style={{
              // Use the row.depth property and paddingLeft to
              // indicate the depth of the row
              paddingLeft: `${row.depth * 0.9}rem`,
            }}>
              <IconButton icon={row.getIsExpanded() ? iconTypes.triangleDown : iconTypes.triangle}
                          onClick={() => {
                            row.toggleExpanded(!row.getIsExpanded())
                          }}/>
            </div>
          ) : null,
      },
      {
        Header: 'Style Name',
        id: 'name',
        accessor: (row) => row.name,
        className: 'pattern-styles-name-column',
        inputType: 'text',
        Cell: ({ row }) => <input
          type="text"
          defaultValue={row.original.name}
          onBlur={(event) => {
            const updatedValue = event.target.value
            const unitId = row.original.id

            onUnitChange(unitId, { name: updatedValue })
          }}
        />
      },
      {
        Header: 'Used Pattern',
        id: 'usedPattern',
        className: 'pattern-styles-selection-column',
        inputType: 'select',
        accessor: (row) => row.patternType,
        Cell: ({ row }) => <TableUsedPatternSelectButton value={row.original.patternType}
                                                                                             unitId={row.original.id}
                                                                                             onChange={(unitId, unit) => onUnitChange(unitId, unit)}
                                                                                             usePattern={row.original.usePattern}/>,
      },

      {
        Header: 'Individual Storage',
        id: 'individualStorage',
        accessor: (row) => row.individualStorage,
        className: 'pattern-styles-toggle-column',
        Cell: ({ row }) => <ToggleSwitch value={row.original.individualStorage}
                                                                             onChange={() => onUnitChange(row.original.id, { individualStorage: !row.original.individualStorage })}/>,
      },
      {
        Header: 'Face Separators',
        id: 'faceSeparators',
        accessor: (row) => row.faceSeparator,
        className: 'pattern-styles-toggle-column',
        Cell: ({ row }) => <ToggleSwitch value={row.original.faceSeparator}
                                                                             onChange={() => onUnitChange(row.original.id, { faceSeparator: !row.original.faceSeparator })}/>,
      },
      {
        Header: 'Back Separators',
        id: 'backSeparators',
        accessor: (row) => row.backSeparator,
        className: 'pattern-styles-toggle-column',
        Cell: ({ row }) => <ToggleSwitch value={row.original.backSeparator}
                                                                             onChange={() => onUnitChange(row.original.id, { backSeparator: !row.original.backSeparator })}/>,
      },
      {
        Header: 'Side Separators',
        id: 'sideSeparators',
        accessor: (row) => row.sideSeparator,
        className: 'pattern-styles-toggle-column',
        Cell: ({ row }) => <ToggleSwitch value={row.original.sideSeparator}
                                                                             onChange={() => onUnitChange(row.original.id, { sideSeparator: !row.original.sideSeparator })}/>,
      },
      {
        Header: 'Workplaces per bench',
        id: 'maxWorkplacesPerBench',
        className: 'pattern-styles-number-column',
        accessor: (row) => row.maxWorkplacesPerBench,
        Cell: ({ row }) => <NumberInput value={row.original.maxWorkplacesPerBench}
                                                                            step={1}
                                                                            digits={0}
                                                                            onChange={(value) => onUnitChange(row.original.id, { maxWorkplacesPerBench: value })}/>,
      },
      {
        Header: 'Workplaces per row',
        id: 'maxWorkplacesPerRow',
        className: 'pattern-styles-number-column',
        accessor: (row) => row.maxWorkplacesPerRow,
        Cell: ({ row }) => <NumberInput value={row.original.maxWorkplacesPerRow}
                                                                            step={1}
                                                                            digits={0}
                                                                            onChange={(value) => onUnitChange(row.original.id, { maxWorkplacesPerRow: value })}/>,
      },
    ],
    [],
  )

  return (
    <EditableTable className='pattern-styles-units-table'
                   columns={columns}
                   data={data}
                   onCellValueChange={(unitId, unit) => onUnitChange(unitId, unit)}
    />
  )

}

export default PatternStylesTable